import React, { useEffect, useState } from 'react';
import { TYPE, useTheme } from '../../theme';
import { Button, Dialog } from '../ui';
import { modApi } from './moderationApi';
import { SUPPORT_PATH } from '../../pages/SupportPage';
import { SUSPENDED_EVENT, takeSuspended } from './suspended';

// AS1c · Visar en varning från admin (en gång) och beskedet när ett avstängt konto försökt logga in.

/** Samma standardtext som API:t (services/moderation.ts DEFAULT_WARNING). */
export const DEFAULT_WARNING_TEXT = 'Du har fått en varning från Qvenari eftersom något du delat bröt mot användarvillkoren. Upprepas det kan kontot stängas av.';

export function ModerationNotice({ userEmail }: { userEmail?: string | null }) {
  const T = useTheme();
  const [suspended, setSuspended] = useState<string | null>(() => takeSuspended());
  const [warning, setWarning] = useState<string | null>(null);

  useEffect(() => {
    const show = () => { const m = takeSuspended(); if (m) setSuspended(m); };
    window.addEventListener(SUSPENDED_EVENT, show);
    return () => window.removeEventListener(SUSPENDED_EVENT, show);
  }, []);

  useEffect(() => {
    if (!userEmail) return;
    let off = false;
    modApi.me().then(s => { if (!off && s.warning) setWarning(s.warning.text); }).catch(() => {});
    return () => { off = true; };
  }, [userEmail]);

  if (suspended) {
    return (
      <Dialog open onClose={() => setSuspended(null)} title="Kontot är avstängt"
        actions={<>
          <Button variant="secondary" onClick={() => { window.location.href = SUPPORT_PATH; }}>Kontakta support</Button>
          <Button onClick={() => setSuspended(null)}>Stäng</Button>
        </>}>
        <p role="alert" style={{ ...TYPE.body, color: T.textSub, margin: 0 }}>{suspended}</p>
      </Dialog>
    );
  }
  if (warning) {
    const ack = () => { setWarning(null); modApi.ackWarning().catch(() => {}); };
    return (
      <Dialog open onClose={ack} title="Varning från Qvenari" actions={<Button onClick={ack}>Jag förstår</Button>}>
        <p role="alert" style={{ ...TYPE.body, color: T.text, margin: '0 0 10px', whiteSpace: 'pre-wrap' }}>{warning}</p>
        <p style={{ ...TYPE.small, color: T.textSub, margin: 0 }}>
          Läs <a href="/villkor" style={{ color: T.accentText }}>användarvillkoren</a>. Har vi fel? <a href={SUPPORT_PATH} style={{ color: T.accentText }}>Kontakta support</a>.
        </p>
      </Dialog>
    );
  }
  return null;
}
